var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "parent-container",
      staticClass: "container-voucher-generator",
      style: _vm.globalStyles
    },
    [
      _c("transition", { attrs: { name: "step" } }, [
        _vm.currentStep === 1
          ? _c("div", { ref: "step1", staticClass: "step-1" }, [
              _c("div", { staticClass: "logo-app" }, [
                _c("div", { staticClass: "logo" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://content.vivaaerobus.com/Upload-VB/vb-logo.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "logo" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "http://content.vivaaerobus.com/cdn/img/laboratio-aries-logo.jpeg"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spacer quarter" }),
              _vm._v(" "),
              _c("h3", { staticClass: "txt-center" }, [
                _vm._v("Validación de reserva")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "spacer quarter" }),
              _vm._v(" "),
              _vm.showError
                ? _c("div", { staticClass: "error-badge" }, [
                    _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src:
                            "https://content.vivaaerobus.com/cdn/vouchers/warning_ico.png"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _c("p", [_vm._v(_vm._s(_vm.errorMessage))])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "inputs" }, [
                _c("div", { staticClass: "input" }, [
                  _c("label", { attrs: { for: "reservationCode" } }, [
                    _vm._v("Clave de reservación")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.pnr,
                        expression: "pnr"
                      }
                    ],
                    staticClass: "viva-input",
                    attrs: {
                      type: "text",
                      placeholder: "6 caracteres",
                      maxlength: "6",
                      name: "reservationCode",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.pnr },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.pnr = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input" }, [
                  _c("label", { attrs: { for: "password" } }, [
                    _vm._v("Contraseña de acceso")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    staticClass: "viva-input",
                    attrs: {
                      type: "password",
                      placeholder: "Contraseña",
                      maxlength: "100",
                      name: "password",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "viva-btn",
                    class: { loading: _vm.loadingButton },
                    attrs: {
                      disabled:
                        _vm.pnr === "" ||
                        _vm.password === "" ||
                        _vm.pnr.length < 6
                    },
                    on: { click: _vm.validatePNR }
                  },
                  [
                    _vm._v("Entrar"),
                    _c("span", { staticClass: "vb-loader" }, [_vm._v("X")])
                  ]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", [
        _vm.currentStep === 2
          ? _c(
              "div",
              { ref: "step2", staticClass: "step-2" },
              [
                _c("h3", [_vm._v("Detalles de la reservación ")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "A continuación, se presenta la información actualizada del itinerario ligado a la reserva ingresada.\n            "
                  )
                ]),
                _vm._v(" "),
                _vm._l(_vm.reserveDetail, function(rd, index) {
                  return [
                    _c(
                      "div",
                      { key: index },
                      [
                        _c("div", { staticClass: "flight-pnr-info" }, [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  rd.MostrarItinerario && rd.Valido
                                    ? rd.nombres
                                    : _vm.nameMask(rd.nombres)
                                ) +
                                  "\n                                " +
                                  _vm._s(
                                    rd.MostrarItinerario && rd.Valido
                                      ? rd.apellidos
                                      : _vm.nameMask(rd.apellidos)
                                  )
                              )
                            ]),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                rd.MostrarItinerario && rd.Valido
                                  ? rd.correo
                                  : ""
                              )
                            ),
                            rd.MostrarItinerario && rd.Valido
                              ? _c("br")
                              : _vm._e(),
                            _vm._v(
                              _vm._s(
                                rd.MostrarItinerario && rd.Valido
                                  ? rd.telefono
                                  : ""
                              ) + "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("h4", { staticClass: "uppercase" }, [
                            _vm._v(_vm._s(_vm.pnr))
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(rd.VuelosDetalle, function(vd, indexvd) {
                          return [
                            [
                              (vd.TipoVuelo !== "Directo"
                              ? indexvd === 0 ||
                                indexvd + 1 === rd.VuelosDetalle.length
                                ? true
                                : false
                              : true)
                                ? _c(
                                    "div",
                                    {
                                      key: indexvd,
                                      staticClass: "flight-detail"
                                    },
                                    [
                                      _c("div", { staticClass: "left" }, [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.humanDestination[vd.Origen]
                                              ) +
                                                " -\n                                            " +
                                                _vm._s(
                                                  _vm.humanDestination[
                                                    vd.Destino
                                                  ]
                                                )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          vd.TipoVuelo !== "Directo"
                                            ? _c(
                                                "span",
                                                { staticClass: "connection" },
                                                [
                                                  _c("small", [
                                                    _vm._v(
                                                      "(Vuelo con\n                                                conexión)"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e()
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.formatDate(vd.STD)))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "right" }, [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(vd.Origen) +
                                                " - " +
                                                _vm._s(vd.Destino)
                                            )
                                          ])
                                        ])
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ]
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(rd.NumeroPasajeros) +
                              "\n                        Pasajero" +
                              _vm._s(rd.NumeroPasajeros > 1 ? "s" : "")
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "viva-btn",
                              class: { loading: _vm.loadingButton },
                              attrs: {
                                disabled:
                                  _vm.pnr === "" ||
                                  _vm.password === "" ||
                                  _vm.pnr.length < 6
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setStep(1)
                                }
                              }
                            },
                            [
                              _vm._v("Nueva Búsqueda"),
                              _c("span", { staticClass: "vb-loader" }, [
                                _vm._v("X")
                              ])
                            ]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }),
                _vm._v(" "),
                _c("br")
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }